// Centralized API base configuration
// Prefer env var; in dev fallback to localhost; in prod default to same-origin

const fromEnv = process.env.REACT_APP_API_BASE;

// If your API is hosted separately in production, set REACT_APP_API_BASE on Vercel.
// Leaving PROD_FALLBACK as "" uses relative URLs (same-origin) in production.
const PROD_FALLBACK = "";

export const API_BASE =
  fromEnv || (process.env.NODE_ENV === "development" ? "http://localhost:5001" : PROD_FALLBACK);


